import { Prop, Vue } from 'vue-property-decorator';

export class AddJobForm extends Vue {
	@Prop()
	public jobType!: string;

	@Prop()
	public sensorFaultReasonOptions!: { text: string; value: any }[];

	@Prop()
	public transceiverFaultReasonOptions!: { text: string; value: any }[];

	@Prop()
	public faultReasonOptions!: { text: string; value: any }[];

	@Prop()
	public v: any;

	public updateValidation() {
		this.$emit('input');
	}
}
